import React, { Component } from 'react';
import './SectorPopup.css';
import PopupTitleBar from './PopupTitleBar';
import SelectionBox from '../SelectionBox';
import Config from '../../Configs/criteria.json';

export default class SectorPopup extends Component {
    constructor(props) {
        super(props);
        // this.handleSelectionBoxChange = this.handleSelectionBoxChange.bind(this);
        // this.closePopupHandler = this.closePopupHandler.bind(this);
        // this.handleSelectAll = this.handleSelectAll.bind(this);
        // this.handleConfirm = this.handleConfirm.bind(this);
        this.sector = [...props.sector];
        this.state = { 
            sector: this.sector 
        };
    }
    handleSelectionBoxChange = (name, value, ischecked) => {
        // this.sector = this.state.sector;
        this.sector[value] = ischecked;
        this.setState({ sector: this.sector });
    }
    closePopupHandler = () => {
        this.props.closePopup();
    }
    handleSelectAll = () => {
        let checked = true;
        if (this.isSelectAllSectorChecked()) {
            checked = false;
        }
        for (let i=0; i<Config.criteria.sector.length; i++) {
            this.sector[i] = checked;
        }
        this.setState({ sector: this.sector });
    }
    handleConfirm = () => {
        this.props.submit(this.state.sector);
        this.closePopupHandler();
    }
    isSelectAllSectorChecked = () => {
        for (let i=0; i<this.sector.length; i++) {
            if (this.sector[i]===false) {
                return false;
            }
        }
        return true;
    }
    render() {
        return (
            <div className={this.props.appId==="Hyper"?"SectorPopup Hyper":"SectorPopup"}>
                <PopupTitleBar title="業種選択" closePopup={this.closePopupHandler} />
                <div className="sectorboxes">
                    {
                        Config.criteria.sector.map((sector, idx) => (
                            <SelectionBox key={sector.id} label={sector.name} name="sector" value={idx} onChange={this.handleSelectionBoxChange} ischecked={this.state.sector[idx]} count={this.props.data["cs"+sector.id]}/>
                        ))
                    }
                    <div style={{clear: "both"}} />
                </div>
                <SelectionBox key="selectall" type="selectall" label="すべて選択する" name="selectall" value="" onChange={this.handleSelectAll} ischecked={this.isSelectAllSectorChecked()} />
                <div style={{clear: "both"}} />
                <div className="confirmbtn" onClick={this.handleConfirm}>適用</div>
            </div>
        );
    }
}